import styles from './GoogleMapWithShimmer.module.scss';
const LoadGoogleMapWithShimmer = () => {
  return <div className={`${styles['map-skeleton']}`} data-sentry-component="LoadGoogleMapWithShimmer" data-sentry-source-file="GoogleMapWithShimmer.tsx"></div>;
};
export default LoadGoogleMapWithShimmer;